import React from 'react';
// @ts-ignore
import GlobalizeProvider from '@sprinx/react-globalize/GlobalizeProvider';
// import loadable from '@loadable/component';
// import ComponentLoader from './AppComponentLoader';
import CldrLocaleCs from '@sprinx/react-globalize/CldrLocaleCs';
import { useRecoilValue } from 'recoil';
import MessagesCs from './MessagesCs';
import { localeState, supportedLocaleCodesState } from './api/appState';

// CLDRS
// const CldrLocaleCs = loadable(() => import('@sprinx/react-globalize/CldrLocaleCs'), { fallback: <ComponentLoader /> });

// Messages
// const MessagesCs = loadable(() => import('./MessagesCs'), { fallback: <ComponentLoader /> });

export interface AppGlobalizeProps {
  children: React.ReactNode;

  /**
   * Defaultni jazyk.
   */
  // defaultLocale?: string;

  // /**
  //  * Handler zmeny preferovaneho jazuku.
  //  *
  //  * Signatura: `(languageCode) => void`
  //  */
  // onPreferredLanguageChanged?: (languageCode: string) => void;

  // supportedLocales: string[] | { code: string }[];
}

const AppGlobalize: React.FC<AppGlobalizeProps> = ({
  children,
  // defaultLocale = 'en',
  // onPreferredLanguageChanged,
  // supportedLocales,
}) => {
  const defaultLocale = useRecoilValue(localeState);
  const supportedLocales = useRecoilValue(supportedLocaleCodesState);

  return (
    <GlobalizeProvider
      cldrs={{ cs: CldrLocaleCs }}
      messages={{ cs: MessagesCs }}
      defaultLocale={defaultLocale || 'cs'}
      supportedLocales={supportedLocales || ['cs']}
      // onPreferredLanguageChanged={onPreferredLanguageChanged}
      dontResolveLocale
      // defferInitialization={onAuth}
      // cache={cache}
      // loadSetting={loadLanguageSetting}
      // onPreferredLanguageChanged={onPreferredLanguageChanged}
    >
      {children}
    </GlobalizeProvider>
  );
};

export default AppGlobalize;
